import React from 'react';
import ScoresDisplay from '../components/ScoresDisplay';
import '../pages/Pages.css';

function Scores() {
  return <ScoresDisplay />;
}

export default Scores;
